import { lazy, Suspense } from "react";

// Kept out of src/routes.js so the build-time pre-renderer never touches the
// signed-in app, and lazy so the marketing pages don't download it.
const AppRoot = lazy(() => import("./AppRoot"));

export const appRoutes = [
  {
    path: "/app/*",
    element: (
      <Suspense fallback={null}>
        <AppRoot />
      </Suspense>
    ),
  },
  // Collection invite links (/c/<id>?k=…). The share function serves this
  // same bundle with the collection's preview embedded (see
  // functions/collectionPage.js).
  {
    path: "/c/*",
    element: (
      <Suspense fallback={null}>
        <AppRoot section="invite" />
      </Suspense>
    ),
  },
];
